import { render } from "./RatingsListDev.vue?vue&type=template&id=d8ae53d0&scoped=true"
import script from "./RatingsListDev.vue?vue&type=script&lang=js"
export * from "./RatingsListDev.vue?vue&type=script&lang=js"

import "./RatingsListDev.vue?vue&type=style&index=0&id=d8ae53d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8ae53d0"]])

export default __exports__